/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  StorageQuota,
} from '../models/index';
import {
    StorageQuotaFromJSON,
    StorageQuotaToJSON,
} from '../models/index';

export interface GetArchiveRequest {
    archiveId: string;
    sessionId?: string;
}

export interface GetStorageCostRequest {
    sessionId?: string;
}

export interface GetStorageQuotaRequest {
    sessionId?: string;
}

export interface GetStorageUsageRequest {
    sessionId?: string;
}

export interface ListArchivesRequest {
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface SetStorageQuotaRequest {
    storageQuota: StorageQuota;
    sessionId?: string;
}

/**
 * DataGovernanceApi - interface
 * 
 * @export
 * @interface DataGovernanceApiInterface
 */
export interface DataGovernanceApiInterface {
    /**
     * Get detailed information about an archive
     * @summary Get archive by ID
     * @param {string} archiveId Archive ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGovernanceApiInterface
     */
    getArchiveRaw(requestParameters: GetArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about an archive
     * Get archive by ID
     */
    getArchive(requestParameters: GetArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get estimated storage costs for the tenant
     * @summary Get storage costs
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGovernanceApiInterface
     */
    getStorageCostRaw(requestParameters: GetStorageCostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get estimated storage costs for the tenant
     * Get storage costs
     */
    getStorageCost(requestParameters: GetStorageCostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get storage quota configuration for the tenant
     * @summary Get storage quota
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGovernanceApiInterface
     */
    getStorageQuotaRaw(requestParameters: GetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get storage quota configuration for the tenant
     * Get storage quota
     */
    getStorageQuota(requestParameters: GetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get current storage usage for the tenant (database and blob storage)
     * @summary Get storage usage
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGovernanceApiInterface
     */
    getStorageUsageRaw(requestParameters: GetStorageUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get current storage usage for the tenant (database and blob storage)
     * Get storage usage
     */
    getStorageUsage(requestParameters: GetStorageUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get paginated list of archives for the tenant
     * @summary List archives
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGovernanceApiInterface
     */
    listArchivesRaw(requestParameters: ListArchivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get paginated list of archives for the tenant
     * List archives
     */
    listArchives(requestParameters: ListArchivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Set storage quota configuration for the tenant
     * @summary Set storage quota
     * @param {StorageQuota} storageQuota 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGovernanceApiInterface
     */
    setStorageQuotaRaw(requestParameters: SetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Set storage quota configuration for the tenant
     * Set storage quota
     */
    setStorageQuota(requestParameters: SetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class DataGovernanceApi extends runtime.BaseAPI implements DataGovernanceApiInterface {

    /**
     * Get detailed information about an archive
     * Get archive by ID
     */
    async getArchiveRaw(requestParameters: GetArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['archiveId'] == null) {
            throw new runtime.RequiredError(
                'archiveId',
                'Required parameter "archiveId" was null or undefined when calling getArchive().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-governance/archives/{archiveId}`;
        urlPath = urlPath.replace(`{${"archiveId"}}`, encodeURIComponent(String(requestParameters['archiveId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about an archive
     * Get archive by ID
     */
    async getArchive(requestParameters: GetArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getArchiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get estimated storage costs for the tenant
     * Get storage costs
     */
    async getStorageCostRaw(requestParameters: GetStorageCostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-governance/storage-cost`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get estimated storage costs for the tenant
     * Get storage costs
     */
    async getStorageCost(requestParameters: GetStorageCostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getStorageCostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get storage quota configuration for the tenant
     * Get storage quota
     */
    async getStorageQuotaRaw(requestParameters: GetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-governance/storage-quota`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get storage quota configuration for the tenant
     * Get storage quota
     */
    async getStorageQuota(requestParameters: GetStorageQuotaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getStorageQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current storage usage for the tenant (database and blob storage)
     * Get storage usage
     */
    async getStorageUsageRaw(requestParameters: GetStorageUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-governance/storage-usage`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get current storage usage for the tenant (database and blob storage)
     * Get storage usage
     */
    async getStorageUsage(requestParameters: GetStorageUsageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getStorageUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of archives for the tenant
     * List archives
     */
    async listArchivesRaw(requestParameters: ListArchivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-governance/archives`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get paginated list of archives for the tenant
     * List archives
     */
    async listArchives(requestParameters: ListArchivesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listArchivesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set storage quota configuration for the tenant
     * Set storage quota
     */
    async setStorageQuotaRaw(requestParameters: SetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['storageQuota'] == null) {
            throw new runtime.RequiredError(
                'storageQuota',
                'Required parameter "storageQuota" was null or undefined when calling setStorageQuota().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/data-governance/storage-quota`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StorageQuotaToJSON(requestParameters['storageQuota']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Set storage quota configuration for the tenant
     * Set storage quota
     */
    async setStorageQuota(requestParameters: SetStorageQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setStorageQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
